import styled from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../common/styled-components/styled-components";
import { breakpoints, device } from '../../../../../../app/js/utils/responsive_utilities';
import { white, whiteLilac, royal, codGrey, deepCoveDark } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../common/mixins/mixin';

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${white};
  ${styledFont("Graphie")}
  padding: 3rem 1.6rem;
  box-sizing: border-box;
`;
export const HeadingText = styled(Heading1)`
  color: ${codGrey};
  margin: auto;
  padding: 3rem 0;
  ${styledFont("Graphie", 2.8, 3.2, 7)};
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 4, 4.4, 7)};
  }
`;

export const SliderContainer = styled.div`
  margin-bottom: 2rem;
  @media (min-width: ${breakpoints.sm}px) {
    padding: 0 8rem; 
  }
  @media ${device.Tablet} {
    padding: 0 12rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    padding: 0 12rem; 
  }
  .slick-dots {
    bottom: 0;
    li {
        button {
            &:before {
              font-size: 6rem;
            }
        }
        &.slick-active button:before {
            color: #69D5C1;
        }
    }
}
`;
export const SliderImageWapper = styled.div`
  width: 100%;
  img {
    border-radius: 3.2rem;
    width: 100%;
    max-width: 100%;
  }
  @media (min-width: ${breakpoints.lg}px) {
    margin-right: 1.5rem;
    padding: 3rem 0;
    width: 67rem;
  }
`;

export const QusnAnsWrapper = styled.div`
  padding: 3rem 0;
  @media (min-width: ${breakpoints.lg}px) {
    width: 47rem;
    margin-left: 1.5rem;
  }
`;

export const Question = styled.h3`
  ${styledFont("Graphie", 2, 2.4, 7)};
  padding: 1rem 0 0.5rem;
  margin: 0;
`;

export const Answer = styled.p`
  ${styledFont("Graphie", 1.6, 2, 4)};
  padding: 1rem 0;
  margin: 0;
`;

export const SlideWrapper = styled.div`
  
  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
    align-items: center;
    margin-bottom: 2.5rem;
  }
`;